import api from "@/lib/api";
import { toast } from "sonner";

export const downloadBlob = async (path, filename, okMsg = "PDF scaricato") => {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success(okMsg);
  } catch (err) {
    toast.error("Download non riuscito");
  }
};
